import { useParticipantsHumansControllerGetHumanWorkPlanQuery } from '@api/admin/adminGeneratedApi';
import { useLazyParticipantsHumansControllerSyncHumanWorkPlanQuery } from '@api/admin/adminApi';
import { useNotifications } from '@area/notifications/hooks/useNotifications';

export const useGetHumanWorkPlan = (id: string, period: string) => {
  const { data, refetch, isLoading, isError, isFetching } = useParticipantsHumansControllerGetHumanWorkPlanQuery({
    id,
    period,
  });
  const [sync, { isLoading: isSyncLoading, isFetching: isSyncFetching }] =
    useLazyParticipantsHumansControllerSyncHumanWorkPlanQuery();
  const { handlePushItem } = useNotifications();

  const syncHumanWorkPlan = async () => {
    if (!data) return;

    try {
      handlePushItem({ severity: 'info', text: 'Запущено обновление успеваемости студента', autoHideDuration: 3000 });

      await sync({ id, period }).unwrap();
      await refetch().unwrap();

      handlePushItem({ severity: 'success', text: 'Успеваемость студента успешно обновлена', autoHideDuration: 3000 });
    } catch (error) {
      handlePushItem({ severity: 'error', text: 'Не удалось обновить успеваемость студента', autoHideDuration: 7000 });
      // eslint-disable-next-line no-console
      console.log(error);
    }
  };

  return {
    data,
    isLoading,
    isError,
    isSyncLoading: isSyncLoading || isSyncFetching || isFetching,
    syncHumanWorkPlan,
  };
};
